angular.module('env.templateResolver', [])

    .service('templateResolver', function ($http, $q, $templateCache) {
        var loadingCache = {};

        var _this = this;

        _.extend(_this, {
            resolve: resolve
        });

        return _this;

        /**
         * Resolve template by url
         * @param {string} templateUrl
         * @returns {Promise} promise of template as string
         */
        function resolve(templateUrl) {
            var template = $templateCache.get(templateUrl);
            if (template) {
                var deferred = $q.defer();
                deferred.resolve(template);
                return deferred.promise;
            }

            if (!loadingCache[templateUrl]) {
                loadingCache[templateUrl] = $http.get(templateUrl)
                    .then(function (response) {
                        delete loadingCache[templateUrl];
                        $templateCache.put(templateUrl, response.data);
                        return response.data;
                    });
            }

            return loadingCache[templateUrl];
        }
    })

;
